import { IAppState } from '../../types/redux';

export const selectPikPromoBanner = (state: IAppState) => {
  return state.pikPromoBanner;
};
